import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-[80vh] w-full bg-white">
      {/* Image */}
      <div className="w-full h-56 sm:h-80 md:h-[600px] lg:h-[700px] relative">
        <img
          src="/images/Picture1.webp"
          alt="Modern building"
          className="object-cover w-full h-full md:rounded-3xl shadow-xl"
        />
        {/* Overlay for gradient fade on left side (optional) */}
        <div className="absolute left-0 top-0 h-full w-1/2 bg-gradient-to-r from-white via-white/80 to-transparent md:rounded-3xl pointer-events-none"></div>
        {/* Content overlays on image for md+ screens */}
        <div className="hidden md:flex absolute top-0 left-0 w-full h-full items-center justify-start">
          <div className="max-w-2xl px-4 sm:px-12 md:px-20 sm:py-10 md:py-10 flex flex-col justify-center items-start md:ml-8 lg:ml-20  bg-white/80 md:bg-transparent rounded-2xl md:rounded-none md:shadow-none shadow md:shadow-none">
            <span className="text-gray-500 text-base mt-10 mb-3 font-semibold">Innovation in Action</span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Engineering the Future:<br />
              <span className="text-red-500">Top-notch MEP Services</span><br />
              You Can Rely On
            </h1>
            <p className="text-gray-800 text-base md:text-lg mb-8 max-w-xl">
              At Milestone Associates, redefine excellence with our unmatched precision, reliability, and innovation in MEP Engineering Design. Elevate your projects with us
            </p>
            <Link to="/contact" className="inline-block bg-red-500 text-white font-semibold text-lg px-8 py-4 rounded transition hover:bg-red-600 shadow-md">
              Inquire Now
            </Link>
          </div>
        </div>
      </div>
      {/* For mobile: show content below image (block on small, hidden on md+) */}
      <div className="block md:hidden px-4 sm:px-16 pt-4 pb-0">
        <span className="text-gray-500 text-base mb-4 font-semibold">Innovation in Action</span>
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 leading-tight">
          Engineering the Future:<br />
          <span className="text-red-500">Top-notch MEP Services</span><br />
          You Can Rely On
        </h1>
        <p className="text-gray-800 text-base mb-8 max-w-xl">
          At Milestone Associates, redefine excellence with our unmatched precision, reliability, and innovation in MEP Engineering Design. Elevate your projects with us
        </p>
        <Link to="/contact" className="inline-block bg-red-500 text-white font-semibold text-lg px-8 py-4 rounded transition hover:bg-red-600 shadow-md">
          Inquire Now
        </Link>
      </div>
    </section>
  );
};

export default Hero; 
